import { Link } from 'react-router-dom';

const quickLinks = [
  { label: '平台评测', to: '/category/pingce' },
  { label: '优惠活动', to: '/category/youhui' },
  { label: '赔率分析', to: '/category/peilv' },
  { label: '安全指南', to: '/category/anquan' },
  { label: '行业资讯', to: '/category/zixun' },
];

const aboutLinks = [
  { label: '关于我们', to: '/about' },
  { label: '品牌故事', to: '/about' },
  { label: '联系我们', to: '/about' },
  { label: '用户协议', to: '/about' },
];

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-200">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="inline-block mb-4">
              <span className="text-2xl font-bold font-heading text-background-50">
                博彩<span className="text-accent-400">网</span>
              </span>
            </Link>
            <p className="text-sm text-background-400 leading-relaxed max-w-xs">
              专业博彩资讯与导航平台，十余年为用户提供最值得信赖的博彩平台评测、优惠活动和赔率分析服务。
            </p>
            <div className="flex items-center gap-3 mt-5">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-md bg-background-800 text-background-300 hover:text-background-50 hover:bg-accent-500 transition-colors duration-200" aria-label="微信">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-md bg-background-800 text-background-300 hover:text-background-50 hover:bg-accent-500 transition-colors duration-200" aria-label="微博">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-md bg-background-800 text-background-300 hover:text-background-50 hover:bg-accent-500 transition-colors duration-200" aria-label="邮箱">
                <i className="ri-mail-line"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 font-label">快速导航</h4>
            <ul className="space-y-2.5">
              {quickLinks.map((link) => (
                <li key={link.to}>
                  <Link to={link.to} className="text-sm text-background-400 hover:text-background-100 transition-colors duration-200 whitespace-nowrap">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 font-label">关于本站</h4>
            <ul className="space-y-2.5">
              {aboutLinks.map((link) => (
                <li key={link.label}>
                  <Link to={link.to} className="text-sm text-background-400 hover:text-background-100 transition-colors duration-200 whitespace-nowrap">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 font-label">免责声明</h4>
            <p className="text-sm text-background-400 leading-relaxed">
              博彩网仅为信息资讯平台，不提供任何形式的博彩投注服务。本站所有内容仅供参考，不构成任何投注建议。请用户遵守所在地区法律法规，理性娱乐。
            </p>
          </div>
        </div>

        <div className="border-t border-background-800 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-background-500">
            &copy; 2014-2024 博彩网 bo-cai-wang.com 版权所有
          </p>
          <p className="text-sm text-background-500">
            理性博彩，健康娱乐 | 未满18周岁请勿参与博彩活动
          </p>
        </div>
      </div>
    </footer>
  );
}